(() => {
  'use strict';

  const EXPERIMENT_ID = 'keauty_popular_signal_v1';
  const ASSIGNMENT_KEY = `${EXPERIMENT_ID}:cohort`;
  const VALID_COHORTS = new Set(['control', 'treatment']);
  const publishedPageEvents = window.__keautyPopularSignalEvents || new Set();
  window.__keautyPopularSignalEvents = publishedPageEvents;

  function randomCohort() {
    try {
      const value = window.crypto.getRandomValues(new Uint32Array(1))[0];
      return value < 0x80000000 ? 'control' : 'treatment';
    } catch (_error) {
      return Math.random() < 0.5 ? 'control' : 'treatment';
    }
  }

  function getCohort() {
    if (VALID_COHORTS.has(window.__keautyPopularSignalCohort)) {
      return window.__keautyPopularSignalCohort;
    }

    let cohort;
    try {
      cohort = window.sessionStorage.getItem(ASSIGNMENT_KEY);
    } catch (_error) {
      cohort = null;
    }

    if (!VALID_COHORTS.has(cohort)) {
      cohort = randomCohort();
      try {
        window.sessionStorage.setItem(ASSIGNMENT_KEY, cohort);
      } catch (_error) {
        // The in-memory assignment below keeps this page internally consistent.
      }
    }

    window.__keautyPopularSignalCohort = cohort;
    return cohort;
  }

  function publish(action, payload) {
    const eventPayload = {
      experiment_id: EXPERIMENT_ID,
      action,
      ...payload
    };

    try {
      const result = window.Shopify?.analytics?.publish?.(
        `${EXPERIMENT_ID}:${action}`,
        eventPayload
      );
      if (result && typeof result.catch === 'function') {
        result.catch(() => {});
      }
    } catch (_error) {
      // Analytics must never interrupt the buying journey.
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'keauty_cro_experiment',
        ...eventPayload
      });
    } catch (_error) {
      // GTM availability is optional; the storefront still works without it.
    }
  }

  class KeautyPopularSignal extends HTMLElement {
    connectedCallback() {
      if (this.keautyConnected) return;
      this.keautyConnected = true;

      this.cohort = getCohort();
      this.currentVariantId = this.dataset.variantId || '';
      this.dataset.cohort = this.cohort;
      this.hidden = this.cohort !== 'treatment';

      this.eventScope = this.closest('.shopify-section') || document;
      this.onVariantChanged = (event) => {
        const variantId = event.detail?.variant?.id;
        if (variantId) this.currentVariantId = String(variantId);
      };
      this.onVariantAdded = (event) => {
        const addedProductId = event.detail?.variant?.product_id;
        const productId = Number(this.dataset.productId);
        if (addedProductId && productId && Number(addedProductId) !== productId) return;

        const variantId = event.detail?.variant?.variant_id || event.detail?.variant?.id;
        publish('add_to_cart', this.payload(variantId));
      };

      this.eventScope.addEventListener('variant:change', this.onVariantChanged);
      this.eventScope.addEventListener('variant:changed', this.onVariantChanged);
      this.eventScope.addEventListener('variant:added', this.onVariantAdded);

      const exposureKey = [
        'exposure',
        window.location.pathname,
        this.dataset.productId,
        this.cohort
      ].join(':');
      if (!publishedPageEvents.has(exposureKey)) {
        publishedPageEvents.add(exposureKey);
        publish('exposure', this.payload());
      }
    }

    disconnectedCallback() {
      if (!this.eventScope) return;
      this.eventScope.removeEventListener('variant:change', this.onVariantChanged);
      this.eventScope.removeEventListener('variant:changed', this.onVariantChanged);
      this.eventScope.removeEventListener('variant:added', this.onVariantAdded);
      this.keautyConnected = false;
    }

    payload(variantId) {
      return {
        cohort: this.cohort,
        signal_shown: this.cohort === 'treatment',
        eligibility: 'most_popular_collection_and_available',
        product_id: this.dataset.productId || '',
        variant_id: String(variantId || this.currentVariantId || ''),
        locale: this.dataset.locale || document.documentElement.lang || '',
        page_path: window.location.pathname
      };
    }
  }

  if (!window.customElements.get('keauty-popular-signal')) {
    window.customElements.define('keauty-popular-signal', KeautyPopularSignal);
  }
})();
